

export const sora = {
    tabs: { textToVideo: '文字转视频', imageToVideo: '图片转视频' },
    upload: { uploadImage: '上传图片', formats: 'JPG、PNG、WebP • 最大 10MB' },
    prompt: { label: '提示词', placeholder: '描述你要生成的视频…', sub: '描述期望的运动与内容', count: '{count} / 5000' },
    model: { title: '模型版本', sora2: 'Sora 2', sora2pro: 'Sora 2 Pro' },
    groups: { aspect: '画面比例', duration: '时长' },
    options: { landscape: '横版', portrait: '竖版', s10: '10秒', s15: '15秒' },
    toggle: { removeWatermark: '移除水印' },
    credits: { bar: '积分消耗', value: '{value} 积分' },
    actions: { generate: '生成视频（{value} 积分）' },
    preview: { title: '准备生成', desc: '输入提示并点击生成，用 Sora 2 创作精彩视频' }
  };
